<!--P078、P084、P085-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy">权限管理</div>
    </div>
    <!--表格-->
    <div class="cs_margin_top_sm div_search_result cs_padding_top_lg">
      <div class="div_operation_table">
        <button @click="btnAdd" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                type="button">添加
        </button>
        <button @click="btnDelete" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                type="button">删除
        </button>
      </div>
      <div class="cs_margin_top div_table">
        <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="100%">角色</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList" :class="{ 'cs_tr_selected': item.isSelected }" @click="btnSelectTableTr(item)">
            <td width="40px">{{index+1}}</td>
            <td width="100%"><a @click.stop="$router.push({name:'RoleDetail', query: {id:item.id,name:item.roleName}})">{{item.roleName}}</a></td>
          </tr>
          <template v-if="PAGE_SIZE>orderList.length">
            <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
              <td width="40px"></td>
              <td width="100%"></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="div_bottom"></div>

    <!--添加弹窗，默认隐藏-->
    <div v-if="isDialogAddShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:400px;height:266px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加角色</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search ui_margin_left_18">角色名称</div>
          <input v-model="nameDialog" @input="nameDialogInput" class="cs_input cs_radius_lg edtxt_info_search width_246" placeholder="请输入">
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog">{{hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialog">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmDialog">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "RoleManage",
    components: {},
    data: function () {
      return {
        orderList: [],
        selectedId: "",
        selectedName: "",
        isDialogAddShow : false,
        nameDialog : "",
        hintDialog : "",
        PAGE_SIZE: 10
      }
    },
    created: function () {
      this.showList();
    },
    mounted: function() {
    },
    methods: {
      showList() {
        this.selectedId = "";
        this.selectedName = "";
        this.$ajax.role.listRole.bind(this)((data) => {
          //显示列表
          let list = data.data;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.orderList = list;
        }, (data) => {
        }, true)
      },
      btnSelectTableTr(item){
        let selectedStatus = item.isSelected;
        this.orderList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedId = item.id;
          this.selectedName = item.roleName;
        }else {
          this.selectedId = "";
          this.selectedName = "";
        }
      },
      btnDelete(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.$alert("确认删除该角色吗？"+"<br><br>角色名称："+this.selectedName, (clickConfirm) => {
          if (clickConfirm) {
            this.$ajax.role.delete.bind(this)(this.selectedId, (data) => {
              this.$toast("删除成功");
              this.showList();
            }, (data) => {
            }, true)
          }
        }, true);
      },
      btnAdd(){
        this.isDialogAddShow = true;
      },
      btnConfirmDialog(){
        if (this.isEmpty(this.nameDialog)) {
          this.hintDialog = "请输入角色名称";
          return
        }
        this.$ajax.role.add.bind(this)(this.nameDialog, (data) => {
          this.$toast("添加成功");
          this.showList();
          this.closeDialog();
        }, (data) => {
        }, true,this.showErrorMsg)
      },
      closeDialog() {
        this.isDialogAddShow = false;
        this.nameDialog = "";
        this.hintDialog = "";
      },
      nameDialogInput(){
        this.hintDialog = "";
      },
      //错误提示
      showErrorMsg: function (msg) {
        this.hintDialog = msg;
      },
    },
  }
</script>

<style scoped>
  .cs_table tbody {
    max-height: 574px;
  }
  .width_246{width: 246px;}
  .txt_hint_dialog{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #FFB54C;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/page/role/RoleManage.vue